/* ==========================================================================
   Hadara — quote page behaviour.

   Deliberately contains NO Liquid. Every label, brand detail and figure is
   read from the JSON block the section renders, so nothing Shopify outputs
   can break this file's syntax. It is served as a static asset and parsed
   by the browser exactly as written.
   ========================================================================== */
(function () {
  'use strict';

  function boot(root) {
    var cfgEl = root.querySelector('[data-quote-config]');
    var dataEl = root.querySelector('[data-quote-data]');

    var stamp = root.querySelector('[data-js-flag]');
    function setFlag(text, cls) {
      if (!stamp) return;
      stamp.textContent = text;
      stamp.className = cls || '';
    }
    setFlag('scripts running', 'is-ok');

    var cfg = {};
    var data = { items: [], showPrices: false };
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent); } catch (e) { setFlag('config unreadable', 'is-err'); }
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) { setFlag('quote data unreadable', 'is-err'); }

    var sheet = root.querySelector('[data-quote-sheet]');

    /* ---------- dynamic terms & conditions ----------
       quote-terms.js owns the editor, the templates and the per-quotation
       save. It is mounted once the reference exists so the saved document is
       keyed to this quotation. */
    var termsApi = null;
    if (window.HadaraTerms && root.querySelector('[data-terms-app]')) {
      termsApi = window.HadaraTerms.mount(root, {
        title: cfg.termsTitle || 'Terms & Conditions',
        defaultTemplate: cfg.termsDefaultTemplate || 'standard',
        bank: cfg.bank || {}
      }, reference(), function () { packTerms(); });
    }

    function termsDoc() {
      if (!cfg.showTermsPdf) return null;
      if (termsApi) return window.HadaraTerms.doc();
      return null;
    }

    function packTerms() {
      var hidden = root.querySelector('[data-rfq-terms]');
      if (!hidden) return;
      hidden.value = termsApi ? window.HadaraTerms.text() : (cfg.terms || []).join('\n');
    }

    /* ---------- reference ---------- */
    function reference() {
      var key = 'hadara-rfq-ref', saved = null;
      try { saved = sessionStorage.getItem(key); } catch (e) {}
      if (saved) return saved;
      var d = new Date(), p = function (n) { return ('0' + n).slice(-2); };
      var ref = 'HAD-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) +
                '-' + Math.floor(100 + Math.random() * 900);
      try { sessionStorage.setItem(key, ref); } catch (e) {}
      return ref;
    }

    function val(name) {
      var el = root.querySelector('[data-rfq="' + name + '"]');
      return el ? String(el.value || '').trim() : '';
    }

    /* ---------- mirror the form into the hidden sheet and the email ---------- */
    function fill() {
      if (!sheet) return;
      ['name', 'company', 'email', 'phone', 'message'].forEach(function (f) {
        var out = sheet.querySelector('[data-ps="' + f + '"]');
        if (!out) return;
        var v = val(f);
        if (f === 'message') {
          var w = sheet.querySelector('[data-ps-msgwrap]');
          if (w) w.style.display = v ? 'block' : 'none';
          out.textContent = v;
        } else {
          out.textContent = v || '\u2014';
        }
      });
      var r = sheet.querySelector('[data-ps="ref"]');
      if (r) r.textContent = reference();
      var dt = sheet.querySelector('[data-ps="date"]');
      if (dt) dt.textContent = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    }

    function packItems() {
      packTerms();
      var hidden = root.querySelector('[data-rfq-items]');
      if (!hidden) return;
      var lines = data.items.map(function (it, i) {
        return (i + 1) + '. ' + it.title + ' | ' + (it.sku || '-') + ' | ' + (it.variant || '-') + ' | qty ' + it.qty;
      });
      hidden.value = 'Reference ' + reference() + '\n' + lines.join('\n');

      var tot = root.querySelector('[data-rfq-totals]');
      if (tot && data.showPrices) {
        var money = function (c) { return (cfg.currency || 'AED') + ' ' + (c / 100).toFixed(2); };
        tot.value = 'Subtotal ' + money(data.subtotal) +
          (data.extraPct > 0 ? ' | Extra discount -' + data.extraPct + '% ' + money(data.extraAmt) : '') +
          ' | VAT ' + data.vatPct + '% ' + money(data.vatAmt) +
          ' | Total ' + money(data.grand);
      }
    }

    /* ---------- status ---------- */
    function setStatus(msg, kind) {
      var el = root.querySelector('[data-pdf-status]');
      if (!el) { if (kind === 'error' && msg) { try { alert(msg); } catch (e) {} } return; }
      el.textContent = msg || '';
      el.className = 'rfq-pdfstatus' + (kind ? ' is-' + kind : '');
      el.hidden = !msg;
    }

    /* ---------- PDF ---------- */
    function quoteData() {
      return {
        brand: cfg.brand, tagline: cfg.tagline, docTitle: cfg.docTitle,
        email: cfg.email, phone: cfg.phone, address: cfg.address,
        domain: cfg.domain, trn: cfg.trn, footer: cfg.footer,
        logoUrl: cfg.logoUrl || null,
        reference: reference(),
        date: new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }),
        currency: data.currency,
        showPrices: data.showPrices,
        items: data.items,
        labels: cfg.labels || {},
        termsLabel: cfg.termsLabel || 'Payment terms',
        sectionSubtotalLabel: cfg.sectionSubtotalLabel || 'Section subtotal',
        termsTitle: cfg.termsTitle || 'Terms & conditions',
        terms: cfg.showTermsPdf ? currentTerms() : [],
        termsDoc: termsDoc(),
        sectionOrder: data.sectionOrder || cfg.sectionOrder || '',
        otherLabel: data.otherLabel || 'Other',
        deliveryLabel: cfg.deliveryLabel || 'Delivery time',
        totals: {
          listTotal: data.listTotal, dealerPct: data.dealerPct, subtotal: data.subtotal,
          extraPct: data.extraPct, extraAmt: data.extraAmt, net: data.net,
          vatPct: data.vatPct, vatAmt: data.vatAmt, total: data.grand
        },
        fields: {
          name: val('name'), company: val('company'), email: val('email'),
          phone: val('phone'), message: val('message')
        },
        filename: 'Hadara-Quotation-' + reference() + '.pdf'
      };
    }

    var btn = root.querySelector('[data-rfq-print]');
    function download() {
      var b = btn || root.querySelector('[data-rfq-print]');
      if (!b || b.disabled) return;
      var original = b.innerHTML;
      b.disabled = true;
      b.classList.add('is-busy');
      b.textContent = cfg.busyLabel || 'Preparing your PDF\u2026';
      setStatus(cfg.busyNote || 'Building the quotation.', 'busy');

      var finish = function () {
        b.disabled = false;
        b.classList.remove('is-busy');
        b.innerHTML = original;
      };

      Promise.resolve()
        .then(function () {
          if (!window.HadaraQuotePDF) throw new Error('LIB_MISSING');
          var d = quoteData();
          if (!d.items || !d.items.length) throw new Error('NO_ITEMS');
          fill();
          packItems();
          return window.HadaraQuotePDF.generate(d, {}, function (stage) {
            var t = {
              building: 'Laying out the quotation\u2026',
              saving: 'Saving your PDF\u2026'
            };
            setStatus(t[stage] || cfg.busyNote || 'Working\u2026', 'busy');
          });
        })
        .then(function () {
          setStatus(cfg.doneLabel || 'Downloaded.', 'ok');
          setTimeout(function () { setStatus(''); }, 4000);
          finish();
        })
        .catch(function (err) {
          console.error('[Hadara] Quote PDF failed:', err);
          var msg = cfg.errorLabel || 'The PDF could not be generated.';
          if (err && err.message === 'LIB_MISSING') msg = 'PDF engine not found. Check that assets/quote-pdf.js exists in the theme.';
          else if (err && err.message === 'NO_ITEMS') msg = 'There are no products in your quote list yet.';
          setStatus(msg, 'error');
          finish();
        });
    }

    if (btn) btn.addEventListener('click', download);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-rfq-print]') && e.target.closest('[data-rfq-print]') !== btn) download();
    });

    /* Clause text as it stands right now, including any edits made on the page. */
    function currentTerms() {
      if (termsApi) return window.HadaraTerms.flat();
      var out = [];
      var live = root.querySelectorAll('[data-term], [data-term-static]');
      if (live.length) {
        for (var i = 0; i < live.length; i++) {
          var t = (live[i].value !== undefined ? live[i].value : live[i].textContent) || '';
          t = t.trim();
          if (t) out.push(t);
        }
        return out;
      }
      return (cfg.terms || []).slice();
    }

    /* ---------- sections: move between, and reorder ----------
       Shopify keeps line item properties on the cart, so the chosen section
       survives a page reload and reaches the PDF and the email. Reordering
       works by rewriting the whole cart in the new order, which is the only
       way Shopify allows lines to be sequenced. */
    function changeLine(line, payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({ line: line }, payload))
      }).then(function (r) { return r.json(); });
    }

    function setSection(row, line, name) {
      row.classList.add('is-updating');
      var props = {};
      props['Section'] = name;
      changeLine(line, { properties: props })
        .then(function () { window.location.reload(); })
        .catch(function () {
          row.classList.remove('is-updating');
          alert('Could not move the item. Please try again.');
        });
    }

    /* Rebuild the cart with two lines swapped. */
    function swapLines(a, b) {
      var busy = root.querySelector('[data-rfq-items-list]');
      if (busy) busy.style.opacity = '.5';
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items.slice();
          if (a < 1 || b < 1 || a > items.length || b > items.length) throw new Error('range');
          var tmp = items[a - 1];
          items[a - 1] = items[b - 1];
          items[b - 1] = tmp;

          /* clear, then re-add in the required order */
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  items: items.map(function (it) {
                    return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
                  })
                })
              });
            });
        })
        .then(function () { window.location.reload(); })
        .catch(function (e) {
          console.error('[Hadara] reorder failed:', e);
          if (busy) busy.style.opacity = '';
          alert('Could not reorder the items. Please try again.');
        });
    }

    /* ---------- send by email ---------- */
    function money(c) {
      var v = Number(c);
      if (!isFinite(v)) v = 0;
      return (data.currency || 'AED') + ' ' + (v / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function emailBody() {
      var L = [];
      L.push(cfg.emailIntro || 'Please find our quotation below.');
      L.push('');
      L.push('Reference: ' + reference());
      L.push('Date: ' + new Date().toLocaleDateString());
      L.push('');
      L.push('ITEMS');
      data.items.forEach(function (it, i) {
        L.push((i + 1) + '. ' + it.title +
               '\n   Model ' + (it.sku || '-') +
               (it.variant ? '  |  ' + it.variant : '') +
               '\n   Qty ' + it.qty +
               (data.showPrices ? '  |  Unit ' + money(it.unit) + '  |  Line ' + money(it.line) : ''));
      });
      if (data.showPrices) {
        L.push('');
        L.push('SUMMARY');
        if (data.dealerPct) {
          L.push('List price total: ' + money(data.listTotal));
          L.push('Dealer discount -' + data.dealerPct + '%: -' + money(data.listTotal - data.subtotal));
        }
        L.push((cfg.labels && cfg.labels.subtotal ? cfg.labels.subtotal : 'Subtotal') + ': ' + money(data.subtotal));
        if (data.extraPct > 0) {
          L.push((cfg.labels && cfg.labels.extra ? cfg.labels.extra : 'Extra discount') + ' -' + data.extraPct + '%: -' + money(data.extraAmt));
          L.push((cfg.labels && cfg.labels.net ? cfg.labels.net : 'Net before VAT') + ': ' + money(data.net));
        }
        L.push((cfg.labels && cfg.labels.vat ? cfg.labels.vat : 'VAT') + ' ' + (data.vatPct || 0) + '%: ' + money(data.vatAmt));
        L.push((cfg.labels && cfg.labels.total ? cfg.labels.total : 'Total incl. VAT') + ': ' + money(data.grand));
      }
      L.push('');
      if (val('message')) { L.push(''); L.push('Notes: ' + val('message')); }
      if (termsApi) {
        var tt = window.HadaraTerms.text();
        if (tt) { L.push(''); L.push(tt); }
      } else {
        var tl = currentTerms();
        if (tl.length) {
          L.push('');
          L.push((cfg.termsTitle || 'Terms & conditions').toUpperCase());
          tl.forEach(function (t, i) { L.push((i + 1) + '. ' + t); });
        }
      }
      L.push('');
      L.push('--');
      L.push(cfg.brand || 'Hadara Technology');
      L.push([cfg.email, cfg.phone, cfg.domain].filter(Boolean).join('  |  '));
      return L.join('\n');
    }

    var emailBtn = root.querySelector('[data-rfq-email]');
    if (emailBtn) {
      emailBtn.addEventListener('click', function () {
        var to = val('email');
        if (!to) {
          setStatus('Add the customer email address first, then press Send by email.', 'error');
          var f = root.querySelector('[data-rfq="email"]');
          if (f) f.focus();
          return;
        }
        /* download the PDF first so it is ready to attach */
        var pdfReady = Promise.resolve();
        if (window.HadaraQuotePDF && data.items.length) {
          pdfReady = window.HadaraQuotePDF.generate(quoteData(), {}).catch(function () {});
        }
        setStatus(cfg.emailNote || 'Opening your email app.', 'busy');
        pdfReady.then(function () {
          var href = 'mailto:' + encodeURIComponent(to) +
                     '?subject=' + encodeURIComponent((cfg.emailSubject || 'Quotation') + ' — ' + reference()) +
                     '&body=' + encodeURIComponent(emailBody());
          window.location.href = href;
          setTimeout(function () { setStatus(cfg.emailNote || '', 'ok'); }, 800);
        });
      });
    }

    /* ---------- line quantities ---------- */
    function setLine(row, line, qty) {
      if (row) row.classList.add('is-updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          if (row) row.classList.remove('is-updating');
          alert('Could not update the quantity. Please try again.');
        });
    }

    var list = root.querySelector('[data-rfq-items-list]');
    if (list) {
      list.addEventListener('click', function (e) {
        var row = e.target.closest('[data-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var input = row.querySelector('[data-line-input]');
        var q = input ? (parseInt(input.value, 10) || 0) : 1;
        if (e.target.closest('[data-move-up]')) {
          var ln = parseInt(row.getAttribute('data-line'), 10);
          if (ln > 1) swapLines(ln, ln - 1);
          return;
        }
        if (e.target.closest('[data-move-down]')) {
          var ln2 = parseInt(row.getAttribute('data-line'), 10);
          swapLines(ln2, ln2 + 1);
          return;
        }
        var next = null;
        if (e.target.closest('[data-line-up]')) next = q + 1;
        if (e.target.closest('[data-line-down]')) next = Math.max(0, q - 1);
        if (e.target.closest('[data-line-remove]')) next = 0;
        if (next === null) return;
        setLine(row, line, next);
      });

      list.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-line-input]')) {
          e.preventDefault();
          e.target.blur();
        }
      });

      list.addEventListener('change', function (e) {
        if (e.target.matches('[data-move-section]')) {
          var r = e.target.closest('[data-line]');
          if (!r) return;
          setSection(r, parseInt(r.getAttribute('data-line'), 10), e.target.value);
          return;
        }
        if (!e.target.matches('[data-line-input]')) return;
        var row = e.target.closest('[data-line]');
        if (!row) return;
        var v = parseInt(e.target.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        setLine(row, parseInt(row.getAttribute('data-line'), 10), v);
      });
    }

    var form = root.querySelector('.rfq-form');
    if (form) form.addEventListener('submit', function () { fill(); packItems(); });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-rfq]')) fill();
    });

    fill();
    packItems();

    console.info('[Hadara] quote page ready', {
      build: cfg.build || '?',
      generator: typeof window.HadaraQuotePDF,
      items: data.items.length,
      showPrices: data.showPrices
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-quote-root]');
    for (var i = 0; i < roots.length; i++) {
      try { boot(roots[i]); }
      catch (e) {
        console.error('[Hadara] quote page error:', e);
        var f = roots[i].querySelector('[data-js-flag]');
        if (f) { f.textContent = 'script error: ' + (e && e.message ? e.message : e); f.className = 'is-err'; }
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
